import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PartnerService } from '../../core/services/partner.service';
import { Partner } from '../../shared/interfaces/partner.interface';
import { ActivatedRoute, Router } from '@angular/router';
import { RegistrationFormComponent } from '../../shared/components/registration-form/registration-form.component';

@Component({
  selector: 'app-register-lp',
  standalone: true,
  imports: [CommonModule, RegistrationFormComponent],
  templateUrl: './register-lp.component.html',
  styleUrl: './register-lp.component.scss',
})
export class RegisterLpComponent implements OnInit {
  @ViewChild(RegistrationFormComponent)
  registrationForm!: RegistrationFormComponent;

  partnerActive!: Partner;
  binActive = false;

  constructor(
    private partnerService: PartnerService,
    private router: Router,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.onMonitoringRouter();
  }

  onMonitoringRouter(): void {
    const queryParams = this.route.snapshot.queryParams;
    if (queryParams['partner']) {
      this.onGetPartner(queryParams['partner']);
    } else {
      this.router.navigate(['/not-found']);
    }
  }

  onGetPartner(partnerId: string): void {
    this.partnerService.getPartner(partnerId).subscribe({
      next: (response) => {
        if (response.name !== 'GrupoMadero') {
          this.router.navigate(['/home'], {
            queryParams: { partner: partnerId },
          });
          return;
        }

        this.partnerActive = response;

        if (this.registrationForm) {
          this.registrationForm.form.patchValue({
            companyCode: response.code,
            companyName: response.name,
          });
        }

        response.fields?.forEach((field: any) => {
          if (field.id === '005') {
            this.binActive = true;
          }
        });

        if (this.registrationForm) {
          this.registrationForm.onVerifyBIN();
        }

        if (!response?.benefitAvailable) {
          this.router.navigate(['/not-found']);
        }
      },
      error: (err) => {
        console.log('Erro ao buscar a empresa!');
        this.router.navigate(['/not-found']);
      },
    });
  }
}
